import { localizeCurrencyString } from "@/lib/localize-currency";

/**
 * Choosing a country as the incorporation country switches the revenue
 * options to that country's currency symbol, regardless of the page's own
 * locale. Countries with no symbol of their own (Sweden, Denmark, Other) show
 * `$`, which matches the USD bands the options are written in. Only an empty
 * selection keeps the page's locale.
 */
const COUNTRY_CURRENCY_LOCALE: Record<string, string> = {
  "United States": "en",
  "United Kingdom": "en-GB",
  Australia: "en-AU",
  Ireland: "en-IE",
  Spain: "en-IE",
  Belgium: "en-IE",
  Netherlands: "en-IE",
  Germany: "en-IE",
  Sweden: "en",
  Denmark: "en",
  Other: "en",
};

export const COUNTRY_FIELD_NAME = "0-2/ib_country_incorporated_reported";

export function revenueLocaleForCountry(
  country: unknown,
  pageLocale: string
): string {
  return COUNTRY_CURRENCY_LOCALE[String(country ?? "")] ?? pageLocale;
}

/** Canadian dollars share the `$` sign, so they get a `C$` prefix to be unambiguous. */
const CAD_COUNTRY = "Canada";

/** Revenue band label (written in USD) in the currency of the chosen country. */
export function localizeRevenueLabel(
  label: string,
  country: unknown,
  pageLocale: string
): string {
  if (country === CAD_COUNTRY) return label.replaceAll("$", "C$");
  return localizeCurrencyString(
    label,
    revenueLocaleForCountry(country, pageLocale)
  );
}
